module.exports = __webpack_public_path__ + "static/media/screen3.08b02816.png";